import React from "react";
import Typist from "react-typist";
import "../../App";

const BecomeDeveloperHeader = () => {
  return (
    <div>
      <div
        id="developerHeader"
        className="jumbotron jumbotron-fluid bg-transparent bgstyle text-light min-vh-100 d-flex align-content-center align-items-center flex-wrap m-0"
        style={{ marginBottom: 0 }}
      >
        <div className="container container-fluid text-center ">
          <h1 className="display-1">Become A Developer</h1>
          <Typist className="lead" cursor={{ hideWhenDone: true }} avgTypingDelay={30}>
            <span className="lead">Contact us with your info and attach a resume! Well get back to you if we think  you are a good fit.</span>
          </Typist>
        </div>
      </div>
    </div>
  );
};

export default BecomeDeveloperHeader;
